<template>
    <div>
      <v-list flat two-line class="mt-3 no-gutters">
        <v-list-item>
          <v-list-item-title>            
            <v-autocomplete
              v-model="selected_project"
              :items="get_projects"
              item-value="id"
              item-text="template_name"            
              dense
              outlined              
              return-object
              @change="select_project"></v-autocomplete>
          </v-list-item-title>
          <v-list-item-action class="mr-3 pb-6">
            <v-btn 
              color="#0b4ef3"
              class="white--text"
              rounded
              @click="add_new_project()">Add Project</v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <ListItem
        :setup="project_setup"
        :items="project"
        :header="headersfreetier"
        :template="gettopasstemplate"
        @addchild="addchild"
        @addsection="addsection"
        @editrecord="editrecord"
        @deleteparent="deleteparent"
        @showchecklist="showchecklist"
      />
      <DialogComponent
        :value="addnewsectionmodal"
        v-model="addnewsectionmodal"
        :dialogvalue="dialogvalueparent"
        @closedialog="closedialog"
        @savedata="savesection"
      />
      <DialogComponent
        :value="addchilddialogmodal"
        v-model="addchilddialogmodal"
        :dialogvalue="dialogvalue"
        @closedialog="closedialog"
        @savedata="savedata"
      />
      <DialogComponent
        :value="editchildmodal"
        v-model="editchildmodal"
        :dialogvalue="dialogvalueedit"
        :ddvalues="ddvalues"
        :childdata="getchilddata"
        @closedialog="closedialog"
        @saveeditedchild="saveeditedchild"
        @deletechild="deletechild"
      />
      <DialogWarning 
        v-model="dialogwarningdeletechild"
        :value="dialogwarningdeletechild"
        :dialogsvalue="dialogwarningcontent"
        @donothing="donothingchild"
        @delproject="confirmdeletechild"
      />
      <DialogWarning 
        v-model="dialogwarningdeleteparent"
        :value="dialogwarningdeleteparent"
        :dialogsvalue="dialogwarningcontent"
        @donothing="donothingparent"
        @delproject="confirmdeleteparent"
      />
      <v-row justify="center">
        <v-dialog
          v-model="show_checklist"
          persistent
        >
        <v-toolbar
          dark
          color="primary"
        >
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            @click="show_checklist = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card>
          <v-card-title style="fontSize: 18px;">
            <small>Checklist</small>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col
                cols="4"
                style="border-right: 1px solid gray;"
              >
                <v-list>
                  <v-list-item-group
                    v-model="selectedItem"
                    color="primary"
                  >
                    <v-list-item
                      v-for="(item, i) in project[0].get_checklist"
                      :key="i"
                      @click="showtablechild(item.get_child_tasks)"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-check</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          <small>
                            <strong>{{item.task}}</strong>
                          </small>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col
                cols="8"
              >
                <v-data-table
                  :headers="checklist_headers"
                  :items="get_checklist"
                  class="elevation-1"
                >
                  <template v-slot:item="props">
                    <tr>
                      <td>
                        <small>
                          {{props.item.task}}
                        </small>
                      </td>
                      <td>
                        <v-switch
                          v-model="props.item.is_done"
                        ></v-switch>
                      </td>
                      <td>
                        <v-textarea
                          v-model="props.item.notes"
                          dense
                          outlined
                        >

                        </v-textarea>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
            
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
          >
            close
          </v-btn>
          </v-card-actions>
        </v-card>
        </v-dialog>
      </v-row>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ListItem from '../../components/ListItems.vue'
import DialogComponent from '../../components/DialogComponent.vue'
import DialogWarning from '../../components/DialogWarning.vue'
export default {
  components: {
    ListItem,
    DialogComponent,
    DialogWarning
  },
  props: [
  ],
  data: () => ({
    headersfreetier: [
      { text: 'Task Name', filterable: true, value: 'task_name', class: 'headerColorToBlue'},
      { text: 'Duration', filterable: true, value: 'duration'},
      { text: 'Status', filterable: true, value: 'status'},
      { text: 'Start', filterable: true, value: 'start'},
      { text: 'Finish', filterable: true, value: 'finish'},
      { text: 'Notes', filterable: true, value: 'notes'},
      // { text: 'Media', width: '15%', filterable: false}
    ],
    project_setup: {
      isreal: true,
      prepends: [
        {
          id:       1,
          action:   true,
          label:    'add task',
          icon:     'mdi-plus'
        }
      ],
      buttons: [
        {
          id:       1,
          action:   true,
          label:    'add section',
          dark:     true,
          text:     false,
          class:    'pl-10 pr-10',
          color:    '#0b4ef3',
          icon:     'mdi-plus'
        }
      ]
    },
    addnewsectionmodal: false,
    dialogvalueparent: {
      modal: false,
      reminder: true,
      title: 'add section',
      icon: 'mdi-plus',
      textfield: [
        {
          id:     1,
          label:  'section name',
          hint:   'section name',
          icon:   'mdi-tooltip-text-outline',
          type:   'text'
        }
      ]
    },
    addchilddialogmodal: false,
    dialogvalue: {
      modal: false,
      reminder: true,
      title: 'add task',
      icon: 'mdi-plus',
      textfield: [
        {
          id:     1,
          label:  'task name',
          hint:   'task name',
          icon:   'mdi-tooltip-text-outline',
          type:   'text'
        }
      ]
    },
    editchildmodal: false,
    ddvalues: ['Pending', 'Started', 'On-Hold', 'Waiting-on Info', 'Complete'],
    dialogvalueedit: {
      ppeditchild:  true,
      title:        'Edit Entry',
      icon:         'mdi-pen',
      button: [
        {
          id:       1,
          icon:     'mdi-delete'
        }
      ],
      textfield:          [
        {
          id:       1,
          label:    'task name',
          hint:     'task name',
          icon:     'mdi-tooltip-text-outline',
          type:     'text'
        },
        {
          id:       2,
          label:    'duration',
          hint:     'duration',
          icon:     'mdi-tooltip-text-outline',
          type:     'number'
        },
        {
          id:       1,
          label:    'who',
          hint:     'who',
          icon:     'mdi-tooltip-text-outline',
          type:     'text'
        }
      ],
      date: [
        {
          id:       1,
          label:    'start date',
          hint:     'start date',
          icon:     'mdi-calendar'
        },
        {
          id:       2,
          label:    'finish date',
          hint:     'finish date',
          icon:     'mdi-calendar'
        }
      ],
      dropdown: [
        {
          id:       1,
          label:    'status',
          hint:     'status',
          icon:     'mdi-tooltip-text-outline'
        }
      ],
      textarea: [
        {
          id:         1,
          label:      'notes',
          hint:       'notes',
          icon:       'mdi-tooltip-text-outline'
        }
      ]
    },
    dialogwarningdeletechild: false,
    dialogwarningdeleteparent: false,
    dialogwarningcontent: {
      warningdelete: true,
      title: 'Are you sure you want to delete this entry?',
      content: 'All of the data that belongs to this entry will be deleted, are you sure about this?',
      buttons: [
        {
          id:         2,
          label:      'Yes',
          action:     true,
          class:      '',
          text:       true,
          dark:       false
        },
        {
          id:         1,
          label:      'No',
          action:     false,
          color:      '#0b4ef3',
          text:       false,
          class:      'pl-16 pr-16',
          dark:       true
        },
      ]
    },
    show_checklist: false,
    selectedItem: 0,
    checklist_headers: [
      { text: 'Task', width: '15' },
      { text: 'Done', width: '5' },
      { text: 'Notes', width: '80' }
    ],
    selected_project: null,
  }),

  mounted () {
    this.selected_project = this.getproject;
  },
  created () {
  },
  computed: {
    ...mapGetters({
      getuser:              'auth/getuser',
      gettopasstemplate:    'pp/getToPassTemplate',
      project:              'pp/getproject',
      parent_data:          'pp/getparentdata',
      getproject:           'auth/getproject',
      getchilddata:         'pp/getchilddata',
      get_checklist:        'pp/get_checklist',
      get_projects:         'auth/get_projects'
    })
  },
  methods: {
    ...mapActions({
      set_selected_project:   'auth/set_selected_project',
      set_project_template:   'pp/set_project_template_actions'
    }),
    addchild(){
      this.addchilddialogmodal = true
    },
    closedialog(){
      this.addchilddialogmodal = false
      this.editchildmodal = false
      this.dialogwarningdeletechild = false
      this.dialogwarningdeleteparent = false
      this.addnewsectionmodal = false
    },
    async fetchproject(){
      await this.$axios.get(`projectplanner/getThisTemplate/${this.getproject.template_name}`)
      .then(({data}) => {
        this.$store.dispatch('pp/setproject', data.data)
      })
    },
    showSnackBar(message){
      this.$store.commit("auth/setMessage", 
      {show: true, message: message}, 
      {root: 1})
    },
    async savedata(data){
      const tp = {
        task:           data.input[1],
        id:             this.parent_data.id,
        template_name:  this.parent_data.template_name
      }
      await this.$axios.post('projectplanner/addSubTask', tp)
      .then(({data}) => {
        this.showSnackBar(data.message)
        this.closedialog()
        this.fetchproject()
      })
    },
    addsection(){
      if(this.getuser.info.access_id == 1){
        this.showSnackBar('Please upgade your account to add more section')
        return
      }
      this.addnewsectionmodal = true
      
    },
    async savesection(data){
      let tp = {
        task_name:    data.input[1]
      }
      await this.$axios.post(`projectplanner/addParentItem/${this.getproject.template_name}`, tp)
      .then(({data}) => {
        if(data.response){
          this.closedialog()
          this.fetchproject()
        }
      })
    },
    editrecord(){
      this.editchildmodal = true
    },
    async saveeditedchild(data){
      //console.log(data)
      let tp = {
        status:     data.dropdown,
        start:      data.start,
        finish:     data.finish,
        notes:      data.notes,
        duration:   data.textfield[0].duration,
        task_name:  data.textfield[0].task_name == undefined ? '' : data.textfield[0].task_name,
        who:        data.textfield[0].who,
      }
      await this.$axios.patch(`/projectplanner/editChild/${this.getchilddata.id}`, tp)
      this.closedialog()
      this.fetchproject()
    },
    deletechild(){
      this.dialogwarningdeletechild = true
    },
    donothingchild(){
      this.dialogwarningdeletechild = false
    },
    async confirmdeletechild(){
      const deleteitem = await this.$axios.delete(`projectplanner/deleteChildTask/${this.getchilddata.id}`)
      this.showSnackBar(deleteitem.data.message)
      this.fetchproject()
      this.closedialog()
    },
    deleteparent(){
      this.dialogwarningdeleteparent = true
    },
    donothingparent(){
      this.dialogwarningdeleteparent = false
    },
    async confirmdeleteparent(){
      const deleteparent = await this.$axios.delete(`/deleteTask/${this.parent_data.id}`)
      this.showSnackBar(deleteparent.data.message)
      this.fetchproject()
      this.closedialog()
    },
    showchecklist(){
      this.show_checklist = true
    },
    showtablechild(data){
      this.$store.dispatch('pp/set_checklist', data)
    },
    add_new_project() {
      this.$emit('is_add_project', true);
    },
    select_project() {
      if ( this.selected_project != null) {
        this.set_selected_project(this.selected_project);
        this.fetchproject();
        if (this.selected_project.template_id) {
          this.set_project_template(this.selected_project);
        }
      }
    }
  },
  watch: {
      getproject() {
        this.selected_project = this.getproject;
      }
  }
}
</script>

<style scoped lang="scss">
.no-gutters {
  padding:0;
  margin:0;
}
</style>